var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8955 4.46095L15.7686 3.33401C15.0286 2.59404 14.1502 2.00706 13.1833 1.60659C12.2165 1.20612 11.1803 1 10.1338 1C9.08735 1 8.05112 1.20612 7.0843 1.60659C6.11749 2.00706 5.23902 2.59404 4.49905 3.33401C3.75908 4.07398 3.1721 4.95244 2.77163 5.91926C2.37116 6.88607 2.16504 7.92229 2.16504 8.96877C2.16504 10.0152 2.37116 11.0515 2.77163 12.0183C3.1721 12.9851 3.75908 13.8636 4.49905 14.6035L16.8955 27L29.292 14.6035C30.7864 13.1091 31.626 11.0822 31.626 8.96875C31.626 6.8553 30.7864 4.82842 29.292 3.33399C27.7976 1.83956 25.7707 1 23.6572 1.00001C21.5438 1.00001 19.5169 1.83958 18.0225 3.33401L16.8955 4.46095Z",
    stroke: "#7E7E7E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5239 14H33.0318",
    stroke: "#7E7E7E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.758789 14H8.86056",
    stroke: "#7E7E7E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86035 14.0004L11.6725 7.30469",
    stroke: "#7E7E7E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6729 7.30469L16.7616 17.3482L20.9798 9.983",
    stroke: "#7E7E7E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5244 13.9998L20.98 9.98242",
    stroke: "#7E7E7E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthUnselected);
export default __webpack_public_path__ + "static/media/health_unselected.a6b0e160f7c92d24ad587fa862a604c0.svg";
export { ForwardRef as ReactComponent };